import React from "react"

const AboutMe = () => {
  return (
    <section id="about" className="about-me">
      <p>Here you can find information about my skills and projects! Stay tuned, more projects in coming.</p>
    </section>
  )
}

export default AboutMe
